import { useQuery } from '@tanstack/react-query';
import { CompanyService } from './CompanyService';

export function useCompanySubmissionMethods({ companyId }: { companyId?: number }) {
    const { data, isLoading, isFetching, error } = useQuery(
        ['CompanySubmissionMethods', companyId],
        async () => {
            const service = new CompanyService();

            const methods = await service.getSubmissionMethods(companyId!);

            return methods;
        },
        {
            enabled: !!companyId,
        }
    );

    return {
        data,
        isLoading: isLoading || isFetching,
        error,
    };
}
